<!-- TEXT ("text", "string") -->
<ng-container
  *ngIf="
    (recordDetail.dataType === 'text' || recordDetail.dataType === 'string') &&
    recordDetail.inputType !== 'Array' &&
    recordDetail.inputType?.toUpperCase() !== 'NAICS'
  "
>
  <miq-select
    *ngIf="recordDetail.lookupCategory && !recordDetail.multiSelect && recordDetail.field !== 'confidentiality_f'"
    [(currentValue)]="recordDetail.value"
    (currentValueChange)="broadcastChange()"
    [values]="recordDetail.values"
    [required]="recordDetail.required"
    [UOMValidation]="recordDetail.UOMValidation"
    [warning]="recordDetail.warning"
    [column]="recordDetail"
    [disabled]="isDisabledInput"
    [panelClass]="isRecordDetail ? 'text-upper' : ''"
    [capitalized]="recordDetail.capitalized"
  >
  </miq-select>

  <!-- CONFIDENTIALITY DROPDOWN -->
  <miq-select-confidentiality
    *ngIf="recordDetail.lookupCategory && recordDetail.field === 'confidentiality_f'"
    [(currentValue)]="recordDetail.value"
    (currentValueChange)="broadcastChange()"
    [values]="recordDetail.values"
    [required]="recordDetail.required"
    [UOMValidation]="recordDetail.UOMValidation"
    [warning]="recordDetail.warning"
    [column]="recordDetail"
    [disabled]="isDisabledInput"
    [panelClass]="isRecordDetail ? 'text-upper' : ''"
    [capitalized]="recordDetail.capitalized"
    [record]="record"
  ></miq-select-confidentiality>

  <miq-multi-select-dropdown
    *ngIf="recordDetail.lookupCategory && recordDetail.multiSelect"
    [(currentValue)]="recordDetail.value"
    (currentValueChange)="broadcastChange()"
    [values]="recordDetail.values"
    [required]="recordDetail.required"
    [UOMValidation]="recordDetail.UOMValidation"
    [column]="recordDetail"
    [disabled]="
      (!isNewRecord && (!(recordDetail.parent.update || this.recordDetail.parent.create) || isDisabled)) ||
      (isNewRecord && isDisabled)
    "
    [panelClass]="isRecordDetail ? 'text-upper' : ''"
    [isCloneRecord]="isCloneRecord"
  >
  </miq-multi-select-dropdown>

  <miq-text
    *ngIf="!recordDetail.lookupCategory"
    [(currentValue)]="recordDetail.value"
    (currentValueChange)="broadcastChange()"
    [customConfigs]="customTextConfigs"
    [defaultEmptyValue]="defaultEmptyValue"
    [required]="recordDetail.required"
    [UOMValidation]="recordDetail.UOMValidation"
    [warning]="recordDetail.warning"
    [column]="recordDetail"
    [disabled]="isDisabledInput"
    (clear)="clear.emit($event)"
  >
  </miq-text>
</ng-container>

<!-- TEXT ("textarea") -->
<ng-container *ngIf="recordDetail.dataType === 'textarea'">
  <miq-textarea
    [(currentValue)]="recordDetail.value"
    (currentValueChange)="broadcastChange()"
    [required]="recordDetail.required"
    [UOMValidation]="recordDetail.UOMValidation"
    [warning]="recordDetail.warning"
    [disabled]="isDisabledInput"
    [column]="recordDetail"
  ></miq-textarea>
</ng-container>

<!-- TEXT ARRAYS -->
<ng-container *ngIf="recordDetail.inputType === 'Array'">
  <miq-array-text
    [(currentValue)]="recordDetail.value"
    (currentValueChange)="broadcastChange()"
    [column]="recordDetail"
    [record]="record"
    [isNewRecord]="isNewRecord"
    [disabled]="isDisabledInput"
  >
  </miq-array-text>
</ng-container>

<ng-container *ngIf="recordDetail.inputType?.toUpperCase() === 'NAICS'">
  <miq-record-naics-input
    [recordDetail]="recordDetail"
    [currentValue]="recordDetail.value"
    [disabled]="isDisabledInput"
    (currentValueChange)="broadcastChange()"
    class="detailpage-naicsinput"
  >
  </miq-record-naics-input>
</ng-container>
<!-- NUMERIC ("integer", "numeric") -->
<ng-container
  *ngIf="recordDetail.dataType === 'numeric' || recordDetail.dataType === 'integer' || recordDetail.dataType === 'id'"
>
  <miq-select
    *ngIf="!!recordDetail.lookupCategory; else numberInput"
    [(currentValue)]="recordDetail.value"
    (currentValueChange)="broadcastChange()"
    [values]="recordDetail.values"
    [required]="recordDetail.required"
    [UOMValidation]="recordDetail.UOMValidation"
    [warning]="recordDetail.warning"
    [column]="recordDetail"
    [disabled]="isDisabledInput"
  >
  </miq-select>
  <ng-template #numberInput>
    <miq-number
      [(currentValue)]="recordDetail.value"
      (currentValueChange)="broadcastChange()"
      [required]="recordDetail.required"
      [UOMValidation]="recordDetail.UOMValidation"
      [warning]="recordDetail.warning"
      [allowNegatives]="recordDetail.allowNegatives"
      [format]="recordDetail.dataType !== 'id'"
      [precision]="recordDetail?.options?.format"
      [column]="recordDetail"
      [disabled]="isDisabledInput"
      [dataType]="recordDetail?.dataType"
    >
    </miq-number>
  </ng-template>
</ng-container>

<!-- BOOLEANS ("boolean", "bool") -->
<ng-container *ngIf="recordDetail.dataType === 'boolean' || recordDetail.dataType === 'bool'">
  <miq-select
    *ngIf="recordDetail.inputType === 'Dropdown' || recordDetail.lookupCategory"
    [(currentValue)]="recordDetail.value"
    (currentValueChange)="broadcastChange()"
    [values]="recordDetail.values"
    [required]="recordDetail.required"
    [UOMValidation]="recordDetail.UOMValidation"
    [warning]="recordDetail.warning"
    [column]="recordDetail"
    [disabled]="isDisabledInput"
  >
  </miq-select>
</ng-container>

<!-- DATES ("timestamp without time zone" "timestamp with time zone" "date") -->
<ng-container
  *ngIf="
    recordDetail.dataType === 'timestamp with time zone' ||
    recordDetail.dataType === 'date' ||
    recordDetail.dataType === 'month'
  "
>
  <ng-container *ngIf="recordDetail.inputType === 'Number'; else dateInput">
    <miq-number
      *ngIf="!recordDetail.lookupCategory"
      [(currentValue)]="recordDetail.value"
      (currentValueChange)="broadcastChange()"
      [required]="recordDetail.required"
      [UOMValidation]="recordDetail.UOMValidation"
      [warning]="recordDetail.warning"
      [allowNegatives]="recordDetail.allowNegatives"
      [column]="recordDetail"
      [format]="false"
      [disabled]="isDisabledInput"
      [dataType]="recordDetail?.dataType"
    >
    </miq-number>

    <miq-select
      *ngIf="recordDetail.lookupCategory"
      [(currentValue)]="recordDetail.value"
      (currentValueChange)="broadcastChange()"
      [values]="recordDetail.values"
      [required]="recordDetail.required"
      [UOMValidation]="recordDetail.UOMValidation"
      [warning]="recordDetail.warning"
      [column]="recordDetail"
      [disabled]="isDisabledInput"
    >
    </miq-select>
  </ng-container>

  <ng-template #dateInput>
    <miq-date
      [(currentValue)]="recordDetail.value"
      (currentValueChange)="broadcastChange()"
      [required]="recordDetail.required"
      [warning]="recordDetail.warning"
      [disabled]="isDisabledInput"
      [handleTimezone]="recordDetail.dataType === 'timestamp with time zone'"
      [column]="recordDetail"
      [minDate]="recordDetail?.minDate"
    >
    </miq-date>
  </ng-template>
</ng-container>
